import React, { Component } from 'react'
import styled from 'styled-components'

const Box = styled.div`
  display: flex;
  ${props => props.flexCol && `
    flex-direction: column;
    align-items: center;
  `}
  flex-wrap: wrap;
  width: 100%;
  margin: 1.25rem 0;
  ${props => props.smallMargin && `
    margin: 0.5rem 0;
  `}
  align-items: ${props => props.alignCenter ? 'center' : 'flex-start'};
  justify-content: ${props => props.justifyCenter ? 'center' : 'flex-start'};
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`

export default class Row extends Component {
  render() {
    return <Box {...this.props} />
  }
}



// WEBPACK FOOTER //
// ./src/components/Row/Row.js